module.exports = StaticCmsApp;